(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
class KsMarquee extends HTMLElement {
  constructor () {
    super()

    this.init()

    document.addEventListener('shopify:section:load', (e) => {
      console.log(e.target) 
      if (e.target.querySelector('.ks-marquee')) {
        init()
      }
    })
  }

  init () {
    const list = this.querySelector('ul')
    console.log(list)
    const marqueeWidth = list.scrollWidth
    console.log(list.scrollWidth)
    const marqueeLength = list.querySelectorAll('li').length 

    list.insertAdjacentHTML('beforeEnd', list.innerHTML)

    list.querySelectorAll('li').forEach((item, index) => {
      if (index >= marqueeLength) {
        item.setAttribute('aria-hidden', 'true')
      }
    })

    let style = `
      <style>
        #ks-marquee-${this.dataset.sectionId} ul {
          animation-name: ks-marquee-animation-${this.dataset.sectionId};
          animation-duration: ${this.dataset.animationDuration}s;
        }
        @keyframes ks-marquee-animation-${this.dataset.sectionId} {
          to { transform: translateX(-${marqueeWidth}px); }
        }
      </style>
    `
    if (this.dataset.marqueeDirection === 'right') {
      style += `
        <style>
          @keyframes ks-marquee-animation-${this.dataset.sectionId} {
            from { transform: translateX(-${marqueeWidth}px); }    
            to { transform: 0); }    
          }
        </style>
      `
    }

    this.insertAdjacentHTML('beforeBegin', style)
  }
}
customElements.define('ks-marquee', KsMarquee)


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
     
  if (Shopify.designMode) return

  // Create cookie function
  function createCookie (name, value, days) {
    let date, expires
    if (days) {
      date = new Date()
      date.setDate(date.getDate() + days)
      expires = '; expires=' + date.toUTCString()
    } else {
      expires = ''
    }
    document.cookie = name + '=' + value + expires + '; path=/'
  }

  const dialog = document.querySelector('#ks-newsletter-dialog')

  // Close dialog if clicked outside
  dialog.addEventListener('click', (event) => {
    const withinBoundaries = event.composedPath().includes(dialog.querySelector('.ks-dialog-inner'))

    if (!withinBoundaries) {
      dialog.close() 
    }
  })

  // Close button
  dialog.querySelector('data-dialog-close')?.addEventListener('click', (event) => {
    event.preventDefault()
    dialog.close()
  })

  // Show the dialog if url contains (www.mystore.com/?ks-newsletter-popup)
  if (window.location.href.includes('ks-newsletter-popup')) {
    dialog.showModal() 
    return
  }

  // Do not show the dialog if the cookie is still present (config from settings)
  if (document.cookie.indexOf('ks-newsletter-popup') > -1) {
    return
  }

  (async () => {
    // Show the dialog on page load after some time has passed (config from settings)
    await new Promise(resolve => setTimeout(resolve, Number(dialog.dataset.configDelay) * 1000))

    // Create a cookie so that we don't show the dialog for some time (config from settings)
    createCookie('ks-newsletter-popup', true, Number(dialog.dataset.configDaysToWait))

    dialog.showModal()
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quantity-breaks"] && !Shopify.designMode) return;
  try {
    
  const injectQtyBreaks = () => {
    const wrapper = document.querySelector('#ks-qty-breaks-hidden')

    const productInfo = document.querySelector('product-info')
    const productFormQty = productInfo.querySelector('.product-form__quantity')
    const atcButton = productInfo.querySelector('button[name="add"]')
    const variantData =  JSON.parse(document.querySelector('#ks-qty-breaks [type="application/json"]').textContent)
    // console.log(variantData)

    productInfo.querySelector('#ks-qty-breaks')?.remove()
    
    document.querySelector(wrapper.dataset.injectElement).insertAdjacentHTML(wrapper.dataset.injectElementPosition, `
      ${wrapper.innerHTML}
    `)

    document.querySelectorAll('#ks-qty-breaks input[name="ks-qty-breaks"]').forEach(input => { 
      input.addEventListener('change', () => {

        if (wrapper.dataset.btnAnimate.length) {
          setTimeout(() => {
            productInfo.querySelector('button[name="add"]').classList.add('animate__animated', wrapper.dataset.btnAnimate)
          }, 250)

          setTimeout(() => {
            productInfo.querySelector('button[name="add"]').classList.remove('animate__animated', wrapper.dataset.btnAnimate)
          }, 1500)
        }
      })
    })

    document.querySelectorAll('#ks-qty-breaks .ks-qty-breaks-variant-option select').forEach(elem => {
      elem.addEventListener('change', () => {

        let totalPrice = 0
        const discount = Number(elem.closest('.ks-qty-breaks-list-item').querySelector('input[name="ks-qty-breaks"]').dataset.discount)
        console.log(discount)

        document.querySelectorAll('#ks-qty-breaks [name="ks-qty-breaks"]:checked + label .ks-qty-breaks-variant').forEach(elem => {
          const selectedOptions = []

          elem.querySelectorAll('select').forEach(select => {
            selectedOptions.push(select.value)
          })

          const selectedVariant = variantData.find(variant =>
            JSON.stringify(variant.options) === JSON.stringify(selectedOptions)
          )

          totalPrice += selectedVariant.price
        })
        

        elem.closest('.ks-qty-breaks-list-item').querySelector('.ks-qty-breaks-label-total').innerHTML = `
          ${formatMoney(totalPrice * (100 - discount) / 100).replace('.00', '')} <s>${formatMoney(totalPrice).replace('.00', '')}</s>
        `

      })
    })

    atcButton.classList.remove('button--secondary')

    atcButton.addEventListener('click', async (event) => {
      event.preventDefault()
      
      atcButton.setAttribute('aria-disabled', true)
      atcButton.classList.add('loading')
      atcButton.querySelector('.loading__spinner').classList.remove('hidden')

      const items = []

      document.querySelectorAll('#ks-qty-breaks [name="ks-qty-breaks"]:checked + label .ks-qty-breaks-variant').forEach(elem => {
        const selectedOptions = []

        elem.querySelectorAll('select').forEach(select => {
          selectedOptions.push(select.value)
        })

        const selectedVariant = variantData.find(variant =>
          JSON.stringify(variant.options) === JSON.stringify(selectedOptions)
        )
        items.unshift({
          id: selectedVariant.id,
          quantity: 1
        })
      })

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer')
      let sections = cart.getSectionsToRender().map((section) => section.id)

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items, sections })
      })
      const responseData = await response.json()

      cart.renderContents(responseData)
      if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty')

      atcButton.setAttribute('aria-disabled', false)
      atcButton.classList.remove('loading')
      atcButton.querySelector('.loading__spinner').classList.add('hidden')
    })

    const moneyFormat = document.querySelector('#ks-qty-breaks').dataset.moneyFormat

    function formatMoney (cents) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '')
      }

      let value = ''
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/

      function defaultOption (opt, def) {
        return (typeof opt === 'undefined' ? def : opt)
      }

      function formatWithDelimiters (number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2)
        thousands = defaultOption(thousands, ',')
        decimal = defaultOption(decimal, '.')

        if (isNaN(number) || number == null) {
          return 0
        }

        number = (number / 100.0).toFixed(precision)

        const parts = number.split('.')
        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands)
        const cents = parts[1] ? (decimal + parts[1]) : ''

        return dollars + cents
      }

      switch (moneyFormat.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2)
        break
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0)
        break
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',')
        break
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',')
        break
      }

      return moneyFormat.replace(placeholderRegex, value)
    }
  }
  injectQtyBreaks()

  const listenVariantChanges = () => {
    document.querySelectorAll('variant-selects [name]').forEach(elem => {
      elem.addEventListener('change', () => { 
        document.querySelector('#ks-qty-breaks').style.opacity = '.2'

        setTimeout(async () => { 
          const respoonse = await fetch(window.location.href)
          const text = await respoonse.text()
          const newDocument = new DOMParser().parseFromString(text, 'text/html')

          document.querySelector('#ks-qty-breaks-hidden')
            .replaceWith(newDocument.querySelector('#ks-qty-breaks-hidden'))
          
          injectQtyBreaks()
        }, 500)
      })
    })
  }
  listenVariantChanges()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-videos"] && !Shopify.designMode) return;
  try {
    
class KsShoppableVideos extends HTMLElement {
  constructor () {
    super()

    if (!document.querySelector('#swiper-stylesheet')) {
      const stylesheet = document.createElement('link')
      stylesheet.setAttribute('href', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.css')
      stylesheet.setAttribute('rel', 'stylesheet')
      stylesheet.setAttribute('id', 'swiper-stylesheet')
      stylesheet.setAttribute('integrity', 'sha256-5nkrwjVsiNfKz3NR1k2h5+qt5pS5SF2u9/TIT1hElow=')
      stylesheet.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(stylesheet)
    }

    if (!document.querySelector('#swiper-script')) {
      const script = document.createElement('script')
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.js')
      script.setAttribute('id', 'swiper-script')
      script.setAttribute('integrity', 'sha256-rCACDWCp/VzIh0rsB+ipQCM9XBvO8HNe0fNSOa4sys0=')
      script.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(script)
    }

    setTimeout(() => {
      const slider = new window.Swiper(this.querySelector('.swiper'), this.splideOptions())

      slider.on('slideChange', () => {
        this.querySelector('.swiper').classList.add('swiper-is-changing')
        this.onSlideChange()
      })

      slider.on('slideChangeTransitionEnd', () => {
        this.querySelector('.swiper').classList.remove('swiper-is-changing')
      })
    }, 500)

    this.querySelectorAll('.ks-shoppable-videos-btn-play').forEach(btn => {
      btn.addEventListener('click', () => {
        const video = btn.closest('.ks-shoppable-videos-video-wrapper').querySelector('video')
        this.onVideoPlay(video)
      })
    })

    this.querySelectorAll('video').forEach(video => {
      video.addEventListener('click', () => {
        this.onVideoPlay(video)
      })
    })

    const lazyVideosObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.play()
        }
      })
    }, { rootMargin: '0px 0px 300px 0px' })
    
    this.querySelectorAll('video[data-autoplay="true"]').forEach((el) => {
      lazyVideosObserver.observe(el)
    })
  }

  splideOptions () {
    const partialSlidesMobile = this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1

    /** @type {SwiperOptions} */
    const options = {
      rewind: true,
      speed: Number(this.dataset.sliderSpeed),
      breakpoints: {
        0: { slidesPerView: Number(this.dataset.breakpointXs) * partialSlidesMobile },
        576: { slidesPerView: Number(this.dataset.breakpointSm) },
        768: { slidesPerView: Number(this.dataset.breakpointMd) },
        992: { slidesPerView: Number(this.dataset.breakpointLg) },
        1200: { slidesPerView: Number(this.dataset.breakpointXl) },
        1400: { slidesPerView: Number(this.dataset.breakpointXxl) }
      },
      navigation: {
        enabled: this.dataset.sliderNav === 'true',
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      pagination: {
        enabled: this.dataset.sliderPagination === 'true',
        type: this.dataset.sliderPaginationType,
        el: '.swiper-pagination',
        dynamicBullets: true,
        dynamicMainBullets: 2,
        renderFraction: function (currentClass, totalClass) {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
        }
      },
      scrollbar: {
        enabled: this.dataset.sliderScrollbar === 'true',
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true 
        // hide: true
      },
      autoplay: this.dataset.sliderAutoplay !== '0'
        ? { delay: Number(this.dataset.sliderAutoplay) * 1000 }
        : undefined,
      watchSlidesProgress: true, 
      mousewheel: {
        enabled: true,
        forceToAxis: true
      },
    }
    return options
  }

  onSlideChange () {
    this.querySelectorAll('.ks-shoppable-videos-card').forEach(elem => {
      elem.setAttribute('data-is-playing', 'false')
      elem.querySelector('video')?.pause()
    })
  }

  onVideoPlay (video) {
    const card = video.closest('.ks-shoppable-videos-card')

    this.querySelectorAll('.ks-shoppable-videos-card').forEach(elem => {
      if (elem.dataset.index !== card.dataset.index) {
        elem.setAttribute('data-is-playing', 'false')
        elem.querySelector('video')?.pause()
      }
    })
    
    if (card.dataset.isPlaying === 'true') {
      card.setAttribute('data-is-playing', 'false')
      video.pause()
    } else {
      card.setAttribute('data-is-playing', 'true')
      video.muted = false
      video.play()
    }
  }

}
customElements.define('ks-shoppable-videos', KsShoppableVideos)


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-atc"] && !Shopify.designMode) return;
  try {
    
  class KsStickyAtc extends HTMLElement {
    constructor () {
      super()
      
      // Wait for DOM to be ready and then initialize
      setTimeout(() => {
        this.initializeStickyATC();
      }, 1000);
    }
    
    // Dynamically shrink the price font-size so the entire compare + sale
    // price line always fits on ONE line inside its container. Starts at
    // 13px and steps down by 0.5px until it fits or hits the 8px floor.
    fitPriceToWidth() {
      const priceEl = this.querySelector('.ks-sticky-atc-price');
      if (!priceEl) return;
      const parent = priceEl.parentElement;
      if (!parent) return;
      // Reset first so subsequent runs (variant change / resize) start clean.
      priceEl.style.fontSize = '';
      const MAX = 13;
      const MIN = 8;
      const STEP = 0.5;
      let size = MAX;
      priceEl.style.fontSize = size + 'px';
      // Loop until content fits or we hit the minimum.
      // scrollWidth > clientWidth means overflow.
      while (priceEl.scrollWidth > priceEl.clientWidth + 1 && size > MIN) {
        size -= STEP;
        priceEl.style.fontSize = size + 'px';
      }
    }

    initializeStickyATC() {
      try {
        // Initial fit + on resize + on variant change.
        const scheduleFit = () => requestAnimationFrame(() => this.fitPriceToWidth());
        scheduleFit();
        window.addEventListener('resize', scheduleFit, { passive: true });
        // Re-fit when the sticky-atc bar toggles .show (transitions can
        // temporarily distort measurements).
        const classObserver = new MutationObserver(scheduleFit);
        classObserver.observe(this, { attributes: true, attributeFilter: ['class'] });
        // Re-fit when the variant changes and the price element gets
        // re-rendered by Dawn's product-info.
        if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
          window.subscribe(window.PUB_SUB_EVENTS.variantChange, () => setTimeout(scheduleFit, 50));
        }

        // Find all possible main Add to Cart buttons on the page
        const mainButtons = [
          ...document.querySelectorAll('form[action="/cart/add"] [type="submit"]'),
          ...document.querySelectorAll('.add-to-cart-btn:not(.ks-sticky-atc .add-to-cart-btn)'),
          ...document.querySelectorAll('button[name="add"]:not(.ks-sticky-atc button)'),
          ...document.querySelectorAll('[data-type="add-to-cart-form"] button')
        ];
        
        // Find the main button (try multiple selector approaches)
        let mainButton = null;
        
        if (mainButtons.length > 0) {
          // Use the first found button
          mainButton = mainButtons[0];
          
          // Set up intersection observer to detect when main button is visible
          const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) {
                // Main button is NOT visible, show the sticky ATC
                this.classList.add('show');
                document.body.style.paddingBottom = this.clientHeight + 'px';
              } else {
                // Main button IS visible, hide the sticky ATC
                this.classList.remove('show');
                document.body.style.paddingBottom = '0';
              }
            });
          }, { threshold: 0.1 }); // Consider visible if 10% of the button is in view
          
          // Start observing
          observer.observe(mainButton);
        } else {
          // If no main button found, show sticky ATC after minimal scroll
          window.addEventListener('scroll', () => {
            if (window.scrollY > 200) {
              this.classList.add('show');
              document.body.style.paddingBottom = this.clientHeight + 'px';
            } else {
              this.classList.remove('show');
              document.body.style.paddingBottom = '0';
            }
          });
        }
        
        // Always show sticky ATC when near bottom of page
        window.addEventListener('scroll', () => {
          const scrollPosition = window.scrollY + window.innerHeight;
          const pageHeight = document.body.scrollHeight;
          
          if (pageHeight - scrollPosition < 300) {  // Show when 300px from bottom
            this.classList.add('show');
            document.body.style.paddingBottom = this.clientHeight + 'px';
          }
        });

        // Choose options button
        const btnOptions = this.querySelector('.ks-sticky-atc-btn-choose-options');
        
        btnOptions?.addEventListener('click', () => {
          // Try to find the main button or form and scroll to it
          if (mainButton) {
            mainButton.scrollIntoView({behavior: 'smooth'});
          } else {
            const productForm = document.querySelector('form[data-type="add-to-cart-form"]');
            if (productForm) {
              productForm.scrollIntoView({behavior: 'smooth'});
            }
          }
        });
          
        // New code for quantity buttons
        const quantityInput = this.querySelector('.quantity-input');
        const decreaseBtn = this.querySelector('.decrease-btn');
        const increaseBtn = this.querySelector('.increase-btn');
        const hiddenInput = this.querySelector('.hidden-quantity-input');
        
        // Update quantity
        const updateQuantity = (change) => {
          if (!quantityInput) return;
          
          let currentValue = parseInt(quantityInput.value);
          let newValue = currentValue + change;
          
          // Ensure quantity is at least 1
          if (newValue < 1) newValue = 1;
          
          // Update the visible input value
          quantityInput.value = newValue;
          
          // Update the hidden input if it exists
          if (hiddenInput) {
            hiddenInput.value = newValue;
          }
        };
        
        // Add event listeners for quantity buttons
        if (decreaseBtn) {
          decreaseBtn.addEventListener('click', function() {
            updateQuantity(-1);
          });
        }
        
        if (increaseBtn) {
          increaseBtn.addEventListener('click', function() {
            updateQuantity(1);
          });
        }
      } catch (error) {
        console.error('Error in sticky ATC:', error);
        
        // Fallback - show sticky ATC after minimal scroll
        window.addEventListener('scroll', () => {
          if (window.scrollY > 200) {
            this.classList.add('show');
            document.body.style.paddingBottom = this.clientHeight + 'px';
          } else {
            this.classList.remove('show');
            document.body.style.paddingBottom = '0';
          }
        });
      }
    }
  }
  customElements.define('ks-sticky-atc', KsStickyAtc)

  // Belt + suspenders: actively remove any pincode / zipcode-app UI that
  // gets injected inside the sticky-atc. The zipcode app inserts one copy
  // of the pincode markup .parent().before() for EVERY button[name="add"]
  // it finds on the page — the sticky ATC has one, so it lands inside our
  // bar. CSS hides it visually; this observer removes it from the DOM so it
  // doesn't interfere with layout at all.
  ;(function () {
    if (window.__jhangoStickyZipStripWired) return;
    window.__jhangoStickyZipStripWired = true;
    var ZIP_SELECTORS = '.ZipCodeRestrict, .zipcode_product_page, .zipcodecheck_area, [class*="zipcode"]';
    function stripFromStickyAtc() {
      document.querySelectorAll('.ks-sticky-atc').forEach(function (bar) {
        bar.querySelectorAll(ZIP_SELECTORS).forEach(function (n) {
          // Don't remove the ATC button itself if a matching class attribute
          // accidentally slipped through — only strip zipcode-specific nodes.
          if (n.tagName === 'BUTTON') return;
          n.remove();
        });
      });
    }
    stripFromStickyAtc();
    var mo = new MutationObserver(function () { stripFromStickyAtc(); });
    mo.observe(document.body, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
